import { createSelector } from 'reselect'
import { EmptyArray } from 'lib/array/arrayUtils'
import getTransferItemsView from 'checkout/selectors/view/itemViews/getTransferItemsView'
import { getPromoKeyForLoyaltyItem } from 'lib/promo/promoMappers'

const getCheckoutTransfersPointsCalculationRequest = createSelector(
  (state: App.State) => getTransferItemsView(state),
  (state: App.State) => state.checkout.promo?.loyaltyPointsBonusResultV1,
  (transferViews, loyaltyPointsBonusResultV1): Array<App.LoyaltyPointsEarnCalculationRequest> => {
    if (!transferViews.hasRequiredData) return EmptyArray

    return transferViews.data.map((itemView): App.LoyaltyPointsEarnCalculationRequest => ({
      price: itemView.totals.price,
      loyaltyProductType: 'experience',
      itemId: itemView.item.itemId,
      promoKey: getPromoKeyForLoyaltyItem(loyaltyPointsBonusResultV1, { filter: { itemId: itemView.item.itemId } }),
    }))
  },
)

export default getCheckoutTransfersPointsCalculationRequest
